window.$CQ = typeof $CQ === "undefined" ? window.$ : window.$CQ;
